// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogsPopularFeed":"jz_a bhk_qr bhk_a bhk_w","BlogsPopularFeed__loading":"jz_b"};